<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">Añadir Comentario</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Observaciones generales
                            <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <!-- Comentario -->
                        <div class="row group-filtros">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpObservaciones">Comentario (500 caracteres max.)</label>
                                <textarea style="resize:none" formControlName="Observaciones" [ngClass]="displayFieldCss('Observaciones')"
                                        rows="3"
                                        maxlength="500" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                        value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Observaciones','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </form>
</div>

